// eslint-disable-next-line no-shadow
export enum PaymentMethod {
    CreditCard
}
